import styled from "styled-components";
import { hiddenStyles, colorFullSroll, subText, ellipsis } from "@mixins";
export var TableContainer = styled.div.withConfig({
  displayName: "measurementstablestyles__TableContainer",
  componentId: "sc-eviaha-0"
})(["", ""], function (_ref) {
  var theme = _ref.theme;
  return "\n    overflow-x: auto;\n    width: 100%;\n    padding: 10px 0;\n    ".concat(colorFullSroll(theme, "100%", true), "\n  ");
});
export var StyledTable = styled.table.withConfig({
  displayName: "measurementstablestyles__StyledTable",
  componentId: "sc-eviaha-1"
})(["", ""], function (_ref2) {
  var theme = _ref2.theme;
  return "\n    width: 100%;\n    border-collapse: collapse;\n    border-bottom: 1px solid ".concat(theme.colors.P2, ";\n    border-right: 1px solid ").concat(theme.colors.P2, ";\n  ");
});
export var TableCaption = styled.caption.withConfig({
  displayName: "measurementstablestyles__TableCaption",
  componentId: "sc-eviaha-2"
})(["", ""], hiddenStyles);
export var Th = styled.th.withConfig({
  displayName: "measurementstablestyles__Th",
  componentId: "sc-eviaha-3"
})(["", ""], function (_ref3) {
  var theme = _ref3.theme,
    type = _ref3.type,
    borderMe = _ref3.borderMe;
  return "\n    ".concat(subText(theme), "\n    font-family: ").concat(theme.fonts.robotoMedium, ";\n    white-space: nowrap;\n    height: 40px;\n    padding: 0 10px;\n\n    ").concat(type === "organization" ? "\n      height: 34px;\n      position: sticky;\n      left: 0;\n      background: ".concat(theme.colors.i5, ";\n      z-index: 2;\n      box-shadow: ").concat(borderMe ? "inset -1px 0 0 0 ".concat(theme.colors.P2, ", inset 0 1px 0 0 ").concat(theme.colors.P2, ", inset 1px 0 0 0 ").concat(theme.colors.P2) : "inset -1px 0 0 0 ".concat(theme.colors.P2, ", inset 0 1px 0 0 ").concat(theme.colors.G4, "1a, inset 1px 0 0 0 ").concat(theme.colors.P2), ";\n\n    ") : "", "\n\n    ").concat(type === "period" ? "\n      border-bottom: 1px solid ".concat(theme.colors.P2, ";\n      border-top: 1px solid ").concat(theme.colors.P2, ";\n      border-left: 1px solid ").concat(theme.colors.P2, ";\n\n      &:nth-child(even){\n        background: ").concat(theme.colors.P3, ";\n        color: ").concat(theme.colors.G1, ";\n      }\n      &:nth-child(2){\n        border-left: none;\n      }\n    ") : "", "\n\n    ").concat(type === "gender" ? "\n      border-bottom: 1px solid ".concat(theme.colors.P2, ";\n      &:not(:first-child){ border-left: 1px solid ").concat(theme.colors.P2, "; }\n    ") : "", "\n\n    ").concat(type === "propType" ? "\n      &:not(:first-child){ border-left: ".concat(borderMe ? "1px solid ".concat(theme.colors.P2) : "none", "; }\n    ") : "", "\n  ");
});
export var Tr = styled.tr.withConfig({
  displayName: "measurementstablestyles__Tr",
  componentId: "sc-eviaha-4"
})([""]);
export var Td = styled.td.withConfig({
  displayName: "measurementstablestyles__Td",
  componentId: "sc-eviaha-5"
})(["", ""], function (_ref4) {
  var theme = _ref4.theme,
    borderMe = _ref4.borderMe;
  return "\n    ".concat(subText(theme), "\n    white-space: nowrap;\n    min-width: 70px;\n    text-align: center;\n    padding: 0 20px;\n\n    border-left: ").concat(borderMe ? "1px solid ".concat(theme.colors.P2) : "", ";\n    &:nth-child(2){ border-left: none; }\n    &:not(:first-child){ border-top: 1px solid ").concat(theme.colors.G4, "1a; }\n    &:first-child{\n      box-shadow: inset -1px 0 0 0px ").concat(theme.colors.P2, ";\n      position: sticky;\n      left: 0;\n      background: ").concat(theme.colors.i5, ";\n      z-index: 2;\n    }\n  ");
});
export var OrganizationHeader = styled.div.withConfig({
  displayName: "measurementstablestyles__OrganizationHeader",
  componentId: "sc-eviaha-6"
})(["", ""], function (_ref5) {
  var color = _ref5.color;
  return "\n    &:before {\n      content: '';\n      width: 26px;\n      min-width: 26px;\n      height: 26px;\n      border-radius: 50%;\n      background: ".concat(color, ";\n      margin: auto 7px auto 0;\n    }\n    max-width: 300px;\n    margin: 0;\n    display: flex;\n    text-align: left;\n    align-items: center;\n  ");
});
export var OrganizationHeaderLabel = styled.p.withConfig({
  displayName: "measurementstablestyles__OrganizationHeaderLabel",
  componentId: "sc-eviaha-7"
})(["", ""], function (_ref6) {
  var theme = _ref6.theme;
  return "\n    ".concat(subText(theme), "\n    ").concat(ellipsis, "\n  ");
});